module.exports = __webpack_public_path__ + "img/slider-horizontal-3_fill.681a9f27.svg";